import React from 'react';
import DocsLink from '../../../common/custom/DocsLink';

const BackendlessAuth = () => {
    return (
      <>
        <h5>
          <b>Authentication</b>
        </h5>
        <p>
          Allows you to manage the user authentication on Backendless. The process of Backendless
          Auth installation involves some simple steps which we have covered in depth.
        </p>
        <DocsLink link="https://academy.drapcode.com/docs/backendless/backendless-authentication#2-click-the-install-button" />
      </>
    );
};

export default BackendlessAuth;
